<ng-container *ngIf="!disableContentPage; else contentWithoutWrapper">
  <gatewee-content-page>
    <div page-body class="gw-flex gw-flex-col gw-gap-6">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </gatewee-content-page>
</ng-container>

<ng-template #contentWithoutWrapper>
  <div class="gw-flex gw-flex-col gw-gap-6">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #contentTemplate>
  <div
    class="gw-flex gw-flex-col md:gw-flex-row md:gw-items-center gw-justify-between gw-gap-medium"
  >
    <p class="gw-text-sm gw-text-text-secondary gw-m-0">
      {{ 'features.notifications.subtitle' | translate }}
    </p>

    <button
      *ngIf="unreadCount > 0"
      type="button"
      class="gw-cursor-pointer gw-self-start md:gw-self-auto gw-px-medium gw-py-2x-small gw-rounded-lg gw-text-xs gw-font-semibold gw-text-brand-primary gw-border gw-border-border-normal gw-bg-transparent hover:gw-bg-background-neutral-1-hover gw-transition-colors"
      (click)="markAllAsRead()"
    >
      {{ 'features.notifications.markAllRead' | translate }}
    </button>
  </div>

  <div class="gw-flex gw-flex-wrap gw-gap-2x-small">
    <button
      type="button"
      class="gw-cursor-pointer gw-px-medium gw-py-2x-small gw-rounded-full gw-text-xs gw-font-bold gw-transition-colors"
      [ngClass]="
        filter === 'all'
          ? 'gw-bg-background-accent-1 gw-text-text-primary-on-accent-1'
          : 'gw-bg-background-neutral-1 gw-text-text-secondary hover:gw-bg-background-neutral-1-hover'
      "
      (click)="setFilter('all')"
    >
      {{ 'features.notifications.all' | translate }}
    </button>
    <button
      type="button"
      class="gw-cursor-pointer gw-px-medium gw-py-2x-small gw-rounded-full gw-text-xs gw-font-bold gw-transition-colors"
      [ngClass]="
        filter === 'unread'
          ? 'gw-bg-background-accent-1 gw-text-text-primary-on-accent-1'
          : 'gw-bg-background-neutral-1 gw-text-text-secondary hover:gw-bg-background-neutral-1-hover'
      "
      (click)="setFilter('unread')"
    >
      {{ 'features.notifications.unread' | translate }}
      <span *ngIf="unreadCount > 0">({{ unreadCount }})</span>
    </button>
  </div>

  <div
    *ngIf="notifications.length > 0; else emptyState"
    class="gw-flex gw-flex-col gw-gap-small"
  >
    <button
      *ngFor="let notification of notifications"
      type="button"
      class="gw-w-full gw-text-left gw-p-medium gw-border-base gw-bg-background-elevation-3 gw-rounded-2xl gw-flex gw-items-start gw-gap-small gw-transition-colors"
      [class.gw-cursor-pointer]="isNavigable(notification)"
      [class.hover:gw-bg-background-neutral-1-hover]="isNavigable(notification)"
      [class.gw-border-brand-primary]="isUnread(notification)"
      (click)="onNotificationClick(notification)"
    >
      <gatewee-icon
        icon="@tui.bell"
        class="gw-shrink-0"
        [class.gw-text-status-info]="isUnread(notification)"
        [class.gw-text-text-secondary]="!isUnread(notification)"
        size="20px"
      ></gatewee-icon>

      <div class="gw-min-w-0 gw-flex-1">
        <div
          class="gw-flex gw-flex-col sm:gw-flex-row sm:gw-items-start sm:gw-justify-between gw-gap-2x-small gw-mb-2x-small"
        >
          <p
            class="gw-text-sm gw-font-semibold gw-text-text-primary gw-m-0"
            [class.gw-font-bold]="isUnread(notification)"
          >
            {{ notification.title }}
          </p>
          <span class="gw-text-[11px] gw-text-text-tertiary gw-shrink-0">
            {{ formatDate(notification.createdAt) }}
          </span>
        </div>
        <p class="gw-text-sm gw-text-text-secondary gw-m-0">
          {{ notification.body }}
        </p>
        <p
          *ngIf="notification.readAt as readAt"
          class="gw-text-[11px] gw-text-text-tertiary gw-m-0 gw-mt-2x-small"
        >
          {{ 'features.notifications.readAt' | translate }}:
          {{ formatDate(readAt) }}
        </p>
      </div>

      <gatewee-icon
        *ngIf="isNavigable(notification)"
        icon="@tui.chevron-right"
        iconStyle="primary"
        size="16px"
        class="gw-text-text-secondary gw-shrink-0 gw-mt-3x-small"
      ></gatewee-icon>
    </button>

    <tui-pagination
      *ngIf="total > pageSize"
      class="gw-mt-medium"
      [length]="totalPages"
      [index]="page - 1"
      (indexChange)="onPageChange($event + 1)"
    ></tui-pagination>
  </div>

  <ng-template #emptyState>
    <div
      class="gw-border-base gw-bg-background-elevation-2 gw-rounded-2xl gw-text-center gw-text-text-secondary gw-py-12 gw-px-4"
    >
      <gatewee-icon
        icon="@tui.bell-off"
        iconStyle="primary"
        size="32px"
        class="gw-text-text-tertiary gw-mb-small"
      ></gatewee-icon>
      <p class="gw-text-sm gw-m-0">
        {{ 'features.notifications.empty' | translate }}
      </p>
    </div>
  </ng-template>
</ng-template>
